import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { LessonResult } from '@yandex-int/k-common/typings';
import { createSelector } from 'reselect';

import { getClessonIdFromProps, getStudentIdFromProps } from 'utils/selectors/selectors';

import { ReduxStudentClessonResultStore, StudentClessonResultStore, StudentResult } from './typings';

const getStoreState = <T extends ReduxStudentClessonResultStore>(storeState: T): StudentClessonResultStore =>
    storeState.studentClessonResult;

export const getStudentCLessonResultState = createSelector(
    [getStoreState, getClessonIdFromProps, getStudentIdFromProps],
    (state: StudentClessonResultStore, clessonId: number, studentId: number): StudentResult | null => {
        if (
            !clessonId ||
            !studentId ||
            !state.clessonResult ||
            !state.clessonResult[clessonId] ||
            !state.clessonResult[clessonId][studentId]
        ) {
            return null;
        }

        return state.clessonResult[clessonId][studentId];
    }
);

export const getStudentCLessonResult = createSelector(
    [getStudentCLessonResultState],
    (studentResultState: StudentResult | null): LessonResult | null => {
        if (!studentResultState) {
            return null;
        }
        return studentResultState.result;
    }
);

export const getStudentCLessonResultLoadingStatus = createSelector(
    [getStudentCLessonResultState],
    (studentResultState: StudentResult | null): LOADING_STATUSES => {
        if (!studentResultState) {
            return LOADING_STATUSES.UNSENT;
        }
        return studentResultState.loadingStatus;
    }
);

export const getShouldLoadCLessonResults = createSelector(
    [getStudentCLessonResultLoadingStatus, getStudentCLessonResult],
    (loadingStatus: LOADING_STATUSES, studentResult: LessonResult | null) =>
        !studentResult && (loadingStatus === LOADING_STATUSES.UNSENT || loadingStatus === LOADING_STATUSES.ERROR)
);
